import $ from 'jquery';

export default (function() {
  const $filters = $('.carriages__filters select');
  const $groups  = $('.carriages__group');

  function init() {
    $filters.on('change', filterItems);
  }

  function filterItems(e) {
    $groups.hide();
    let classesToShow = '';

    $filters.each(function() {
      const value = $( this ).val();
      if(value) {
        classesToShow += '.' + value;
      }
    });

    if(classesToShow){
      $(classesToShow).show();
    } else {
      $groups.show();
    }
  }

  return {
    init: init
  };
})();
